
import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'

@Component
export default class extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'BreadcrumbNav'

  @Prop({ type: Array }) currentPath: Array<any>

  /**
   * 获取面包屑标题
   */
  itemTitle(item: any) {
    return this.L(item.meta.title)
  }
}
